import React,{useState} from 'react';
import PropTypes from 'prop-types';

import Search from '../search/Search.jsx';
import MerchantNumbersList from 'Components/MerchantNumbers/merchant-numbers-list/MerchantNumbersList.jsx';
import OutsideClickHandler from 'Components/OutsideClickHandler';
import SearchIcon from 'Components/icons/SearchIcon';
import classnames from 'classnames';
import TextField from 'Components/forms/text-field/TextField';



import 'Components/forms/forms.styles.js';
import './MerchantNumbers.scss';

const MerchantNumbers = ({ title, onChange, placeHolder, extraClass, searchTerm, dataList, visible, noBorder, onClick, handleOutsideClick, handleChange, handleHeaderCheckbox, toggleCollapse, selectedValue, removeFilterAction, showDynamicFilter, updatedId, name, listHeight, elementId, filterErrorMsg, reportName, isAllMerchantSelected, allMerchantSelectedMsg,isViewFilter, isEditRule, elementLabel, midPage, currentMidCount, updateIsIndeterminate, totalMidCount, selectedMerchantNumbers, totalMidPages, pageLabel, ofLabel, updateIsMerchantIndeterminate, disabledMerchantNumbers, isMreFilterPaneVisible, totalChainPages }) => {
  const autocompleteClass = classnames(noBorder ? 'autocomplete_noborder' : 'code-view-autocomplete', {
    [extraClass]: extraClass,
  });

  const value = searchTerm;
  const lowercaseSearchTerm = value && value.toLowerCase && value.toLowerCase();

  let dataListFiltered = [];
   dataList !== undefined && dataList.map(obj =>{
     if(obj.key!=="null")
        dataListFiltered.push(obj);
  });

  const filteredListTemp = dataListFiltered !== undefined && dataListFiltered.map(u => {
    u.items.map(c => {
      return Object.assign({}, c);
    })
    return Object.assign({}, u);
  });

  const filteredList = filteredListTemp !== false && filteredListTemp.filter((filterItem) => {
    const filteredChildren = filterItem.items.filter((child) => {
      return child.text.toLowerCase().includes(lowercaseSearchTerm);
    });
    filterItem.items = filteredChildren;
    return (filteredChildren.length > 0);
  });

  let displayList = (value !== '' && value !== undefined ) ? filteredList : dataListFiltered;
  let totalSelectedItems = 0;
  displayList && displayList.forEach(element => {
    element.items.forEach(item => {
      item.selected && ++totalSelectedItems;
    })
  });

  updateIsIndeterminate(displayList);

  if (value) {
    for (let i = 0; i < filteredList.length; i++) {
      filteredList[i].isExpanded = true;
    }
  }

  let newPlaceHolder =  `${totalSelectedItems} value(s) are selected`;

  return (
    <div className="reason-code-wrapper">
      <TextField
        htmlFor={title}
        labelContent={title}
        removeFilterAction={removeFilterAction}
        showDynamicFilter={showDynamicFilter}
        updatedId={updatedId}
        callingComponent={elementId == "cq_base_queue" && "CreateCustomQueueLanding"}
        filterErrorMsg={filterErrorMsg}
        reportName ={reportName}
        isRequired={reportName === 'MRE' && elementId === "mre_merchant_numbers" ? true : false}
        isAllMerchantSelected={isAllMerchantSelected}
        allMerchantSelectedMsg={allMerchantSelectedMsg}
      >
        <OutsideClickHandler
          onClickOutside={()=>handleOutsideClick(updatedId)}
        >
          <div className={autocompleteClass} >
            <div role='button' id={name} className="reason-code-srch-mngr" onClick={() => onClick(name)} style={{ border: filterErrorMsg && reportName == 'MRE' ?"1px solid red" : ''}}>
              <div className="reason-code-srch-icon"> <SearchIcon /> </div>
              <Search
                filterText={searchTerm}
                onChange={onChange}
                placeholder={newPlaceHolder}
                filtername={name}
                style={{ width: "200px" }}
                isMreFilterPaneVisible={isMreFilterPaneVisible}
                reportName={reportName}
              />
            </div>
            <MerchantNumbersList
              dataList={displayList}
              handleHeaderCheckbox={handleHeaderCheckbox}
              visible={visible}
              searchTerm={searchTerm}
              extraClass=''
              handleChange={handleChange}
              toggleCollapse={toggleCollapse}
              handleOutsideClick={handleOutsideClick}
              filterName={name}
              listHeight={listHeight}
              elementId={elementId}
              isViewFilter = {isViewFilter}
              midPage = {midPage}
              currentMidCount = {currentMidCount}
              updateIsIndeterminate = {updateIsIndeterminate}
              totalMidCount = {totalMidCount}
              totalMidPages = {totalMidPages}
              pageLabel = {pageLabel}
              ofLabel = {ofLabel}
              totalChainPages = {totalChainPages}
              isMreFilterPaneVisible={isMreFilterPaneVisible}
            />
          </div>
        </OutsideClickHandler>
      </TextField>
    </div>
  );
};

MerchantNumbers.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  onBlur: PropTypes.func,
  isRequired: PropTypes.bool,
  disable: PropTypes.bool,
  hideLabel: PropTypes.bool,
  isWidthFixRequired: PropTypes.bool,
  removeFilterAction: PropTypes.func,
  showDynamicFilter: PropTypes.bool,
  updatedId: PropTypes.string,
};

MerchantNumbers.defaultProps = {
  type: 'text',
  placeholder: '',
  error: '',
  onBlur: null,
  isRequired: false,
  labelTooltip: null,
  hideErrorIcon: true,
  disable: false,
  hideLabel: false,
  isWidthFixRequired: false,
  removeFilterAction: () => { },
  showDynamicFilter: false,
  updatedId: '',
};

export default MerchantNumbers;
